import React from 'react';
import styled, { css } from 'styled-components';

export const ModalCloseButton = (props) => {

  const { onClose, width, height, xColor, xSize, fill, borderHover } = props;
  return (
    <Svg onClick={onClose} className="cursor-pointer" width={width ?? "36"} height={height ?? "36"} viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g>
        <rect width="32" height="32" rx="16" transform="matrix(-1 0 0 1 34 1)" fill={fill ?? "white"} />
        <rect x="-0.5" y="0.5" width="31" height="31" rx="15.5" transform="matrix(-1 0 0 1 33 1)" />
      </g>
      <path d="M20.9989 14.0037L15.0039 19.9974" stroke={xColor ?? window?.settings?.secondary_color ?? "#04333B"} strokeWidth={xSize ?? "1.5"} strokeLinecap="round" strokeLinejoin="round" />
      <path d="M21 20L15 14" stroke={xColor ?? window?.settings?.secondary_color ?? "#04333B"} strokeWidth={xSize ?? "1.5"} strokeLinecap="round" strokeLinejoin="round" />
    </Svg>
  )
}

const Svg = styled.svg`

  stroke: #E3E3E3;
  ${({ theme, displayState }) => css`
    &:hover {
      stroke: ${displayState?.disableborderHover ? null : theme?.colour?.secondary ?? "#04333B"};
    }
  `}
`;